import React, { useEffect, useState } from 'react';
import { useStyles } from './styles';
import InputSearch from './input-search';
import CheckBoxGroup from './checkbox-group';
import RadioGroup from './radio-group';
import ConfirmBar from './confirm-bar';
import { Empty, Spin } from 'antd';
import { debounce } from 'lodash';

const FilterTable = ({
  placeholder,
  dataSource,
  checkedFilters,
  setCheckedFilters,
  isShowFilterTable,
  setShowFilterTable,
  noSearch,
  onChange,
  onSearch,
  isMultiSelect = true,
  use = 'checkboxGroup',
  loading,
  keepSelectResult = false,
  customHeader,
  onScrollEnd,
}) => {
  const classes = useStyles();
  const [checkBoxData, setCheckBoxData] = useState(dataSource);
  const [, setSelectedItem] = useState([]);
  const [checkedList, setCheckedList] = useState(() => {
    if (checkedFilters) return checkedFilters;
    if (use === 'checkBoxGroup') {
      return [];
    } else {
      return {};
    }
  });
  const [isMultiSelectInside, setIsMultiSelectInside] = useState(isMultiSelect);
  const [customHeaderData, setCustomHeaderData] = useState(null);

  const debouncedOnSearch = React.useCallback(
    debounce(searchInfo => {
      onSearch?.(searchInfo);
    }, 500),
    [],
  );

  const handleSearch = searchInfo => {
    debouncedOnSearch(searchInfo);

    if (!keepSelectResult) {
      setCheckedList([]);
    }
  };

  const resetOnClick = () => {
    setCheckedList([]);
    setShowFilterTable(false);
    onChange([]);

    if (customHeader?.onReset) {
      customHeader.onReset();
    }
  };

  const onOkClick = () => {
    setCheckedFilters(checkedList);
    setShowFilterTable(false);

    if (customHeader?.onConfirm && customHeaderData !== null) {
      customHeader.onConfirm({
        customHeaderData,
        checkedList,
      });
    } else {
      onChange(checkedList);
    }
  };

  useEffect(() => {
    if (isShowFilterTable) {
      setCheckedList(checkedFilters);
      setCheckBoxData(dataSource);
    }
  }, [isShowFilterTable, dataSource]);

  const handleOnSelect = checkedList => {
    const checkedItem = checkBoxData.filter(item => checkedList.includes(item.value));
    setSelectedItem(checkedItem);

    if (isMultiSelectInside) {
      setCheckedList(checkedList);
    } else {
      setCheckedList(oldList => checkedList.filter(newItem => !oldList.includes(newItem)));
    }
  };

  return (
    <If condition={isShowFilterTable}>
      <div className={classes.filterTable}>
        <If condition={!noSearch}>
          <InputSearch onChange={handleSearch} placeholder={placeholder} value="" />
        </If>
        <If condition={customHeader}>
          {customHeader.element({
            onChange: v => {
              setCustomHeaderData(v);
            },
            setMultiSelect: v => {
              setIsMultiSelectInside(v);
            },
            clearSelected: () => {
              setCheckedList([]);
            },
          })}
        </If>
        <If condition={!checkBoxData?.length && loading}>
          <div style={{ height: '200px' }} className={classes.loadingbox}>
            <Spin />
          </div>
        </If>
        <If condition={!checkBoxData?.length && !loading}>
          <div style={{ height: '130px' }} className={classes.loadingbox}>
            <Empty />
          </div>
        </If>
        <If condition={!!checkBoxData?.length}>
          <If condition={use === 'radioGroup'}>
            <RadioGroup
              options={checkBoxData}
              value={checkedList}
              onChange={checked => {
                setCheckedList(checked);
              }}
            />
          </If>
          <If condition={use !== 'radioGroup'}>
            <CheckBoxGroup
              isLoading={loading}
              options={checkBoxData}
              value={checkedList}
              onChange={handleOnSelect}
              onScrollEnd={onScrollEnd}
            />
          </If>
        </If>

        <ConfirmBar
          resetOnClick={resetOnClick}
          onOkClick={e => {
            e.stopPropagation();
            onOkClick();
          }}
          disabled={checkedList?.length === 0 && !customHeader?.canReset}
        />
      </div>
    </If>
  );
};

export default FilterTable;
